/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solana_Multiply_Page_Meta_DescriptionInputs */

const en_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const de_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const pt_br2_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const tr_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const zh_cn2_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const zh_hk2_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const ko_kr2_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const ru_ru2_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

const es_419_solana_multiply_page_meta_description = /** @type {(inputs: Solana_Multiply_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino.`)
};

/**
* | output |
* | --- |
* | "Experimental: open and close leveraged SOL positions from your Investing Account on Jupiter Lend or Kamino." |
*
* @param {Solana_Multiply_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const solana_multiply_page_meta_description = /** @type {((inputs?: Solana_Multiply_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solana_Multiply_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solana_multiply_page_meta_description(inputs)
	if (locale === "de") return de_solana_multiply_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_solana_multiply_page_meta_description(inputs)
	if (locale === "tr") return tr_solana_multiply_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_solana_multiply_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_solana_multiply_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_solana_multiply_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_solana_multiply_page_meta_description(inputs)
	return es_419_solana_multiply_page_meta_description(inputs)
});